import React from 'react'
import PropTypes from 'prop-types'
import { AI_RISK_REPORT_PDF_KEEP_CHUNK_WITH_NEXT_ATTRIBUTES, SCORE_IDS } from '../../data/constants'
import { getDomainScore } from '../../data/reportModel'
import SectionHeading from '../../components/SectionHeading/SectionHeading'
import WhyThisMatters from '../../components/WhyThisMatters/WhyThisMatters'
import AppsAndServicePrincipals from './AppsAndServicePrincipals'
import ShadowAi from './ShadowAi'
import TenantAuthz from './TenantAuthz'

export default function ThirdPartyAi({
  summary = {},
  data = {},
  domainScores = [],
  findings = [],
  dataAvailability = [],
}) {
  return (
    <>
      <div {...AI_RISK_REPORT_PDF_KEEP_CHUNK_WITH_NEXT_ATTRIBUTES}>
        <SectionHeading
          id="third-party-ai"
          titleId="AI_RISK_REPORT.SECTION.THIRD_PARTY.TITLE"
          questionId="AI_RISK_REPORT.SECTION.THIRD_PARTY.QUESTION"
        />
        <WhyThisMatters bodyId="AI_RISK_REPORT.SECTION.THIRD_PARTY.WHY" />
      </div>
      <ShadowAi dataAvailability={dataAvailability} />
      <AppsAndServicePrincipals
        summary={summary}
        data={data}
        findings={findings}
        score={getDomainScore(domainScores, SCORE_IDS.APPS_OAUTH)}
        dataAvailability={dataAvailability}
      />
      <TenantAuthz tenant={data.tenant} dataAvailability={dataAvailability} />
    </>
  )
}

ThirdPartyAi.propTypes = {
  summary: PropTypes.shape({}),
  data: PropTypes.shape({
    applications: PropTypes.arrayOf(PropTypes.shape({})),
    servicePrincipals: PropTypes.arrayOf(PropTypes.shape({})),
    tenant: PropTypes.shape({}),
  }),
  domainScores: PropTypes.arrayOf(PropTypes.shape({})),
  findings: PropTypes.arrayOf(PropTypes.shape({})),
  dataAvailability: PropTypes.arrayOf(PropTypes.shape({})),
}
